import { useEffect } from 'react';
import {
	Redirect,
	useHistory,
	useParams,
	Switch,
	Route,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getLifebooksChild, getUserState } from 'redux/selectors';
import { Welcome, Feed, ManageChild } from 'components';
import { useCreateDispatches } from 'helpers/hooks';
import useSnapshotChildListfetch from './utils/useSnapshotChildListfetch';
import SnapshotChildListContainer from './components/SnapshotChildListContainer';
import styles from './snapshots.module.css';

export default function Snapshots({
	basePath = '/archive',
	trustedCaseManagerRoute = false,
} = {}) {
	const { setRoot, setChild } = useCreateDispatches();
	const { childList, sortMenuItems } = useSnapshotChildListfetch({
		enabled: !trustedCaseManagerRoute,
	});
	const { childId, feedType } = useParams();
	const { push } = useHistory();
	const routeRoot = basePath.replace(/^\/+|\/+$/g, '');

	// TODO: set child in redux so that NoPost component renders properly

	const user = useSelector(getUserState);
	const scopedChild = useSelector(getLifebooksChild);

	useEffect(() => {
		setRoot('archive');
		return () => {
			if (!trustedCaseManagerRoute) setChild({});
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [trustedCaseManagerRoute]);

	useEffect(() => {
		if (!trustedCaseManagerRoute || !scopedChild?.id) return;
		if (!childId || childId !== scopedChild.id) {
			push(`${basePath}/timeline/${scopedChild.id}`);
		}
	}, [
		basePath,
		childId,
		push,
		scopedChild?.id,
		trustedCaseManagerRoute,
	]);

	if (
		trustedCaseManagerRoute &&
		childId &&
		scopedChild?.id &&
		childId !== scopedChild.id
	) {
		return <Redirect to={`${basePath}/timeline/${scopedChild.id}`} />;
	}

	return (
		<div className={styles.archiveContainer}>
			{!trustedCaseManagerRoute && (
				<SnapshotChildListContainer
					childList={childList}
					sortMenuItems={sortMenuItems}
				/>
			)}
			<div className={styles.archiveFeed}>
				<div className={styles.archiveContent}>
					<Switch>
						<Route
							key={childId + 'child'}
							path={`${basePath}/child/:childId`}>
							<div className={styles.archiveProfile}>
								<ManageChild />
							</div>
						</Route>
						<Route
							key={childId + feedType}
							path={`${basePath}/:feedType/:childId`}>
							<Feed routeRoot={routeRoot} />
						</Route>
						<Route path={`${basePath}/`}>
							<Welcome user={user} />
						</Route>
					</Switch>
				</div>
			</div>
		</div>
	);
}
